webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(197);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(304);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Router = __webpack_require__(206);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	var _vuefire = __webpack_require__(314);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _vueValidator = __webpack_require__(313);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _index = __webpack_require__(7);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeFormat = 'YYYY/MM/DD HH:mm:ss';
	
	_vue2.default.use(_vueValidator2.default);
	_vue2.default.use(_Router2.default);
	_vue2.default.use(_vuefire2.default);
	
	_vue2.default.validator('email', function (val) {
	  return (/^[-a-z0-9~!$%^&*_=+}{\\'?]+(\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(val)
	  );
	});
	
	_vue2.default.filter('timeFormat', function (value) {
	  return (0, _moment2.default)(value).format(timeFormat);
	});
	
	_vue2.default.filter('fromNow', function (value) {
	  return (0, _moment2.default)(value).fromNow();
	});
	
	var router = new _Router2.default({
	  history: true
	});
	var application = _vue2.default.extend({
	  store: _index.store,
	  components: { App: _App2.default }
	});
	router.start(application, 'body');

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.naturalSorting = exports.filterOptions = exports.getAuthState = exports.store = exports.AUTH_STATE_AUTHED = undefined;
	
	var _promise = __webpack_require__(52);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(33);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(31);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var checkUserProfile = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2) {
	    var uid = _ref2.uid,
	        email = _ref2.email;
	    var snapshot, userProfileRef;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return userRef.once('value');
	
	          case 2:
	            snapshot = _context.sent;
	
	            if (snapshot.hasChild(uid)) {
	              _context.next = 7;
	              break;
	            }
	
	            userRef.child(uid).set({
	              role: 'vendor',
	              email: email
	            });
	            _context.next = 12;
	            break;
	
	          case 7:
	            _context.next = 9;
	            return userRef.child(uid).once('value');
	
	          case 9:
	            userProfileRef = _context.sent;
	
	            console.log(userProfileRef.val());
	            store.dispatch('userProfile', userProfileRef.val());
	
	          case 12:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function checkUserProfile(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var getAuthState = exports.getAuthState = function () {
	  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            if (!(storedState.authState === AUTH_STATE_AUTHING)) {
	              _context2.next = 6;
	              break;
	            }
	
	            _context2.next = 3;
	            return delay(1);
	
	          case 3:
	            console.log('waiting auth');
	            _context2.next = 0;
	            break;
	
	          case 6:
	            return _context2.abrupt('return', storedState.authState === AUTH_STATE_AUTHED);
	
	          case 7:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function getAuthState() {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	exports.login = login;
	exports.resetPassword = resetPassword;
	exports.firebaseLogout = firebaseLogout;
	exports.getFireBase = getFireBase;
	exports.getFirmwareRef = getFirmwareRef;
	exports.getFwSwitchRef = getFwSwitchRef;
	exports.getNetworkModelRef = getNetworkModelRef;
	exports.getNetworkFamilyRef = getNetworkFamilyRef;
	exports.getNetworkProductionRef = getNetworkProductionRef;
	exports.getFWPiRef = getFWPiRef;
	exports.getSwitchRef = getSwitchRef;
	exports.getSwitchHistory = getSwitchHistory;
	exports.getSmartCtrlRef = getSmartCtrlRef;
	exports.getSmartCtrlHistory = getSmartCtrlHistory;
	exports.getSmartCtrlActRef = getSmartCtrlActRef;
	exports.getPMIB = getPMIB;
	exports.getModelForUI = getModelForUI;
	exports.getCustomForUI = getCustomForUI;
	exports.getCustomFromLabel = getCustomFromLabel;
	exports.getCategoryFromLabel = getCategoryFromLabel;
	
	var _vue = __webpack_require__(197);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(315);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _firebase = __webpack_require__(286);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firebaseRef = __webpack_require__(207);
	
	var _firebaseRef2 = _interopRequireDefault(_firebaseRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_firebase2.default.initializeApp(_firebaseRef2.default);
	
	var userRef = _firebase2.default.database().ref('user');
	
	
	_firebase2.default.auth().onAuthStateChanged(function (user) {
	  if (user) {
	    console.log(user);
	    checkUserProfile(user);
	  }
	  store.dispatch('user', user || {});
	
	  store.dispatch('authed', user !== null);
	});
	
	var AUTH_STATE_AUTHING = 0;
	var AUTH_STATE_NOAUTH = 1;
	var AUTH_STATE_AUTHED = exports.AUTH_STATE_AUTHED = 2;
	var storedState = {
	  authState: AUTH_STATE_AUTHING,
	  user: {},
	  firmware: {
	    category: '',
	    custom: ''
	  },
	  isMibFilterStoreEmpty: true,
	  mibFliterStore: {
	    category: '',
	    custom: '',
	    model: '',
	    family: ''
	  }
	};
	var mutations = {
	  authed: function authed(state, _authed) {
	    state.authState = _authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH;
	  },
	  user: function user(state, content) {
	    state.user = {
	      email: content.email
	    };
	  },
	  userProfile: function userProfile(state, profile) {
	    state.user = (0, _extends3.default)({}, state.user, profile);
	  },
	  mibInfoSelected: function mibInfoSelected(state, mibInfo) {
	    console.log('mutation mibInfoSelected');
	
	    state.mibFliterStore = mibInfo;
	    state.isMibFilterStoreEmpty = false;
	    console.log(state.mibFliterStore);
	  },
	  deleteMibFilterInfo: function deleteMibFilterInfo(state) {
	    state.mibFliterStore = {
	      category: '',
	      custom: '',
	      model: '',
	      family: ''
	    };
	    state.isMibFilterStoreEmpty = true;
	    console.log('deleteMibFilterInfo');
	  },
	  firmwareInfoSelected: function firmwareInfoSelected(state, firmwareInfo) {
	    state.firmware = (0, _extends3.default)({}, state.firmware, firmwareInfo);
	  },
	  firmwareInfoDelete: function firmwareInfoDelete(state) {
	    state.firmware = (0, _extends3.default)({}, state.firmware, {
	      category: '',
	      custom: ''
	    });
	  }
	};
	
	_vue2.default.use(_vuex2.default);
	var store = exports.store = new _vuex2.default.Store({
	  state: storedState,
	  mutations: mutations,
	  strict: ("production") !== 'production'
	});
	
	function login() {
	  var _firebase$auth;
	
	  return (_firebase$auth = _firebase2.default.auth()).signInWithEmailAndPassword.apply(_firebase$auth, arguments);
	}
	
	function resetPassword(mail) {
	  return _firebase2.default.auth().sendPasswordResetEmail(mail);
	}
	
	function firebaseLogout() {
	  return _firebase2.default.auth().signOut();
	}
	
	function delay() {
	  var sec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (sec > 10) return console.log('delay cannot bigger than 10s');
	  return new _promise2.default(function (resolve) {
	    setTimeout(resolve, sec * 1000);
	  });
	}
	
	function getFireBase() {
	  return _firebase2.default;
	}
	
	function getFirmwareRef() {
	  return _firebase2.default.database().ref('firmware');
	}
	
	function getFwSwitchRef() {
	  return _firebase2.default.database().ref('firmware/switch/storage');
	}
	
	function getNetworkModelRef() {
	  return _firebase2.default.database().ref('network/model');
	}
	
	function getNetworkFamilyRef() {
	  return _firebase2.default.database().ref('network/family');
	}
	
	function getNetworkProductionRef() {
	  return _firebase2.default.database().ref('network/product');
	}
	
	function getFWPiRef() {
	  return _firebase2.default.database().ref('firmware/pi/storage');
	}
	
	function getSwitchRef() {
	  return _firebase2.default.database().ref('switch/registeration');
	}
	
	function getSwitchHistory() {
	  return _firebase2.default.database().ref('switch/history');
	}
	
	function getSmartCtrlRef() {
	  return _firebase2.default.database().ref('smart-controller/registeration');
	}
	
	function getSmartCtrlHistory() {
	  return _firebase2.default.database().ref('smart-controller/history');
	}
	
	function getSmartCtrlActRef() {
	  return _firebase2.default.database().ref('smart-controller/registerationChange');
	}
	
	function getPMIB() {
	  return _firebase2.default.database().ref('private-mib');
	}
	
	function getModelForUI(model) {
	  switch (model) {
	    case 'ite':
	      return 'ITE';
	    case 'iteHome':
	      return 'ITE Home';
	    case 'aspeed':
	      return 'Aspeed';
	  }
	}
	
	function getCustomForUI(custom) {
	  switch (custom) {
	    case 'gomax':
	      return 'GoMax';
	    case 'gofanco':
	      return 'Gofanco';
	    case 'general':
	      return 'General';
	    case 'lantech':
	      return 'Lantech';
	    case 'turkey':
	      return 'Turkey';
	    case '21net':
	      return '21net';
	    case 'germany':
	      return 'Germany';
	    case 'canada':
	      return 'Canada';
	    case 'hytec':
	      return 'Hytec';
	    case 'lgu+':
	      return 'LGU+';
	    case 'ruf':
	      return 'Ruf';
	    case 'ltdp':
	      return 'Ltdp';
	    case 'tekdis':
	      return 'Tekdis';
	    case 'acrobel':
	      return 'Acrobel';
	    case 'intrising':
	      return 'Intrising';
	    case 'trafsys':
	      return 'Trafsys';
	  }
	}
	
	function getCustomFromLabel(custom) {
	  switch (custom) {
	    case 'GoMax':
	      return 'gomax';
	    case 'Gofanco':
	      return 'gofanco';
	    case 'General':
	      return 'general';
	    case 'Lantech':
	      return 'lantech';
	    case 'Turkey':
	      return 'turkey';
	    case '21net':
	      return '21net';
	    case 'Germany':
	      return 'germany';
	    case 'Canada':
	      return 'canada';
	    case 'Hytec':
	      return 'hytec';
	    case 'LGU+':
	      return 'lgu+';
	    case 'Ruf':
	      return 'ruf';
	    case 'Ltdp':
	      return 'ltdp';
	    case 'Tekdis':
	      return 'tekdis';
	    case 'Acrobel':
	      return 'acrobel';
	    case 'Intrising':
	      return 'intrising';
	  }
	}
	
	function getCategoryFromLabel(custom) {
	  switch (custom) {
	    case 'Switch1':
	      return 'swix1';
	    case 'Switch2':
	      return 'swix2';
	    case 'Wireless':
	      return 'wrouter';
	    case 'Router':
	      return 'router';
	    case 'Router X':
	      return 'routerx';
	  }
	}
	
	var filterOptions = exports.filterOptions = {
	  production: {
	    category: [{ label: 'Switch1', value: 'Switch1' }, { label: 'Switch2', value: 'Switch2' }, { label: 'Wireless', value: 'Wireless' }, { label: 'Router', value: 'Router' }, { label: 'Router X', value: 'Router X' }],
	    custom: [{ label: 'Lantech', value: 'Lantech' }, { label: 'Turkey', value: 'Turkey' }, { label: '21net', value: '21net' }, { label: 'Germany', value: 'Germany' }, { label: 'Canada', value: 'Canada' }, { label: 'Hytec', value: 'Hytec' }, { label: 'LGU+', value: 'LGU+' }, { label: 'Ruf', value: 'Ruf' }, { label: 'Ltdp', value: 'Ltdp' }, { label: 'Tekdis', value: 'Tekdis' }, { label: 'Acrobel', value: 'Acrobel' }, { label: 'Intrising', value: 'Intrising' }, { label: 'Trafsys', value: 'Trafsys' }, { label: 'Undefined', value: 'Undefined' }],
	    status: [{ label: 'Production', value: 'Production' }, { label: 'Develop', value: 'Develop' }, { label: 'Sample', value: 'Sample' }]
	  },
	  firmware: {
	    category: [{ label: 'Switch1', value: 'swix1' }, { label: 'Switch2', value: 'swix2' }, { label: 'Wireless', value: 'wrouter' }, { label: 'Router', value: 'router' }, { label: 'RouterX', value: 'routerx' }],
	    custom: [{ label: 'Lantech', value: 'lantech' }, { label: 'Turkey', value: 'turkey' }, { label: '21net', value: '21net' }, { label: 'Germany', value: 'germany' }, { label: 'Canada', value: 'canada' }, { label: 'Hytec', value: 'hytec' }, { label: 'LGU+', value: 'lgu+' }, { label: 'Ruf', value: 'ruf' }, { label: 'Ltdp', value: 'ltdp' }, { label: 'Tekdis', value: 'tekdis' }, { label: 'Acrobel', value: 'acrobel' }, { label: 'Intrising', value: 'intrising' }, { label: 'Trafsys', value: 'trafsys' }, { label: 'Undefined', value: 'undefined' }],
	    status: [{ label: 'Release', value: 'release' }, { label: 'Develop', value: 'dev' }, { label: 'Beta', value: 'beta' }, { label: 'Disabled', value: 'disabled' }]
	  }
	};
	
	var naturalSorting = exports.naturalSorting = function naturalSorting(data, key) {
	  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
	
	  return option === 'asc' ? data.slice().sort(function (a, b) {
	    return a[key].replace(' ', '').localeCompare(b[key].replace(' ', ''), undefined, { numeric: true });
	  }) : data.slice().sort(function (a, b) {
	    return b[key].replace(' ', '').localeCompare(a[key].replace(' ', ''), undefined, { numeric: true });
	  });
	};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(277)
	__vue_script__ = __webpack_require__(210)
	__vue_template__ = __webpack_require__(298)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(220);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(225);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(227);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(226);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _vueRouter = __webpack_require__(312);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _index = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subPage = {
	  template: '<router-view></router-view>'
	};
	
	var _class = function (_Router) {
	  (0, _inherits3.default)(_class, _Router);
	
	  function _class(arg) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, arg));
	
	    _this.map({
	      '/login': {
	        component: __webpack_require__(310),
	        noauth: true
	      },
	      '/': {
	        name: 'index',
	        component: __webpack_require__(309)
	      },
	      '/smart-controller': {
	        name: 'smart-controller',
	        component: subPage,
	        subRoutes: {
	          '/production': {
	            component: __webpack_require__(311)
	          },
	          '/history': {
	            component: __webpack_require__(308)
	          },
	          '/firmware': {
	            component: __webpack_require__(307)
	          },
	          '/production-activity': {
	            component: __webpack_require__(306)
	          }
	        }
	      }
	    });
	    _this.beforeEach(function (_ref) {
	      var to = _ref.to,
	          next = _ref.next,
	          abort = _ref.abort;
	
	      if (to.path === '/') {
	        _this.replace('/smart-controller/production');
	      }
	      if (to.matched === null) {
	        console.log('state is null');
	        abort();
	        _this.replace('/');
	      } else if (to.noauth) {
	        (0, _index.getAuthState)().then(function (state) {
	          console.log('to.noauth', state);
	          if (state) _this.replace('/');else next();
	        });
	      } else {
	        (0, _index.getAuthState)().then(function (state) {
	          if (state) {
	            return next();
	          }
	          abort();
	          _this.replace('/login');
	        });
	      }
	    });
	    return _this;
	  }
	
	  return _class;
	}(_vueRouter2.default);
	
	exports.default = _class;

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  apiKey: 'AIzaSyBADcOJtn4eZEY4v_R22ILHOkbHis9Knc4',
	  authDomain: 'intrihub-98da3.firebaseapp.com',
	  databaseURL: 'https://intrihub-98da3.firebaseio.com',
	  storageBucket: 'intrihub-98da3.appspot.com',
	  messagingSenderId: '1085157336669'
	};

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueStrap = __webpack_require__(16);
	
	var _package = __webpack_require__(289);
	
	var _index = __webpack_require__(7);
	
	exports.default = {
	  components: {
	    navbar: _vueStrap.navbar,
	    dropdown: _vueStrap.dropdown,
	    alert: _vueStrap.alert
	  },
	  data: function data() {
	    return {
	      version: _package.version,
	      alertList: [],
	      alertData: {
	        type: '',
	        title: '',
	        show: false,
	        content: ''
	      }
	    };
	  },
	  vuex: {
	    getters: {
	      user: function user(state) {
	        return state.user;
	      },
	      authed: function authed(state) {
	        return state.authState === _index.AUTH_STATE_AUTHED;
	      }
	    }
	  },
	  methods: {
	    logout: function logout() {
	      var _this = this;
	
	      (0, _index.firebaseLogout)().then(function () {
	        window.setTimeout(function () {
	          _this.$router.go('/login');
	        }, 1000);
	      });
	    },
	    alert: function alert(_ref) {
	      var type = _ref.type,
	          title = _ref.title,
	          content = _ref.content;
	
	      console.log(type);
	      console.log(title);
	      console.log(content);
	      var newAlert = {
	        type: type,
	        title: title,
	        content: content,
	        show: true
	      };
	      this.alertList.push(newAlert);
	    }
	  },
	  events: {
	    alert: function alert(e) {
	      console.log(e);
	      this.alert(e);
	    }
	  },
	  ready: function ready() {
	    var _this2 = this;
	
	    setInterval(function () {
	      if (_this2.alertList.length) {
	        _this2.alertData = _this2.alertList.shift();
	        _this2.alertData.show = false;
	        setTimeout(function () {
	          _this2.alertData.show = true;
	        }, 1500);
	      }
	    }, 2000);
	  }
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String
	    },
	    content: {
	      type: String
	    },
	    class: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    uniContent: function uniContent() {
	      return this.content.replace(/\r\n|\n\r|\r/, '\n');
	    },
	    hasBr: function hasBr() {
	      return this.uniContent.indexOf('\n') !== -1;
	    },
	    computedContent: function computedContent() {
	      if (!this.hasBr) {
	        return this.uniContent;
	      } else {
	        return this.uniContent.split('\n');
	      }
	    }
	  },
	  methods: {}
	};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vueStrap = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'v-select': _vueStrap.select
	  },
	  props: {
	    countOfPage: {
	      type: Number,
	      default: 50
	    },
	    currPage: {
	      type: Number,
	      twoway: true,
	      default: 1
	    },
	    countOfPagination: {
	      type: Number,
	      default: 5,
	      twoway: true
	    },
	    currPaginationSec: {
	      type: Number,
	      twoway: true,
	      default: 1
	    },
	    sortMethod: {
	      type: Object,
	      twoway: true,
	      default: function _default() {}
	    },
	    sortMethodOpts: {
	      type: Array,
	      twoway: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    targetAry: {
	      type: Array,
	      twoway: true,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      countOfPageOptions: [{ val: 10, label: 'Amounts Per Page: 10' }, { val: 25, label: 'Amounts Per Page: 25' }, { val: 50, label: 'Amounts Per Page: 50' }, { val: 100, label: 'Amounts Per Page: 100' }]
	    };
	  },
	
	  computed: {
	    paginationStart: function paginationStart() {
	      return (this.currPaginationSec - 1) * this.countOfPagination;
	    },
	    totalSection: function totalSection() {
	      return Math.ceil(this.totalPage / this.countOfPagination);
	    },
	    totalPage: function totalPage() {
	      return Math.ceil(this.targetAry.length / this.countOfPage);
	    },
	    totalPageAry: function totalPageAry() {
	      var ary = [];
	      for (var i = 0; i < this.totalPage; i++) {
	        ary.push(i);
	      }
	      return ary;
	    }
	  },
	  methods: {
	    resetPagination: function resetPagination() {
	      var amount = (this.currPage - 1) * this.countOfPage;
	      var max = this.targetAry.length;
	      if (amount > max) {
	        this.currPage = 1;
	        this.currPaginationSec = 1;
	      }
	    },
	
	    setPage: function setPage(idx) {
	      if (idx <= 0 || idx > this.totalPage) {
	        return;
	      }
	      this.currPage = idx;
	      if (idx > this.currPaginationSec * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec + 1);
	      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec - 1);
	      }
	    },
	    setPaginationSec: function setPaginationSec(idx) {
	      if (idx <= 0 || idx > this.totalSection) {
	        return;
	      }
	      this.currPaginationSec = idx;
	      this.currPage = (idx - 1) * this.countOfPagination + 1;
	    },
	    sortBy: function sortBy() {
	      this.sortMethod = (0, _extends3.default)({}, this.sortMethod, {
	        asc: !this.sortMethod.asc
	      });
	    }
	  }
	};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(51);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(228);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _index = __webpack_require__(7);
	
	var _Pagination = __webpack_require__(29);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _vueStrap = __webpack_require__(16);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: [],
	  components: {
	    'v-select': _vueStrap.select,
	    pagination: _Pagination2.default
	  },
	  data: function data() {
	    return {
	      outputData: [],
	
	      fbSmartCtrlActLoaded: false,
	
	      countOfPage: 10,
	      countOfPagination: 5,
	      currentPage: 1,
	      currPaginationSec: 1,
	
	      filterTypeValue: 'Any',
	      filterTypeOpts: [{ label: 'Any', value: 'Any' }, { label: 'Create', value: 'create' }, { label: 'Delete', value: 'delete' }, { label: 'Update', value: 'update' }],
	      filterModelValue: 'Any',
	      filterModelOpts: [{ label: 'Any', value: 'Any' }, { label: 'ASPEED', value: 'aspeed' }, { label: 'ITE', value: 'ite' }],
	      today: (0, _moment2.default)().format('YYYY-M-D'),
	      filterDateStartValue: '',
	      filterDateEndValue: '',
	      lang: 'en',
	
	      currentSortOptions: {
	        'createdAt': false,
	        'type': null,
	        'data.mac': null,
	        'serialNum': null,
	        'data.model': null,
	        'data.fwVersion': null
	      }
	    };
	  },
	
	  vuex: {
	    getters: {
	      user: function user(state) {
	        return state.user;
	      }
	    }
	  },
	  firebase: function firebase() {
	    var _this = this;
	
	    return {
	      fbSmartCtrlAct: {
	        source: (0, _index.getSmartCtrlActRef)(),
	        readyCallback: function readyCallback() {
	          _this.fbSmartCtrlActLoaded = true;
	        }
	      }
	    };
	  },
	
	  computed: {
	    dataLoading: function dataLoading() {
	      var _this2 = this;
	
	      if (this.user.role === 'admin' && this.fbSmartCtrlActLoaded) {
	        var fbsca = [].concat((0, _toConsumableArray3.default)(this.fbSmartCtrlAct));
	
	        var filterTypeResult = this.filterTypeValue === 'Any' ? fbsca : _lodash2.default.filter(fbsca, function (s) {
	          return s.type === _this2.filterTypeValue;
	        });
	
	
	        var filterModelResult = this.filterModelValue === 'Any' ? filterTypeResult : _lodash2.default.filter(filterTypeResult, function (_ref) {
	          var data = _ref.data;
	          return data.model === _this2.filterModelValue;
	        });
	
	        var filterDateStartRESULT = this.filterDateStartValue === '' ? filterModelResult : _lodash2.default.filter(filterModelResult, function (s) {
	          return s.createdAt >= new Date(_this2.filterDateStartValue).getTime();
	        });
	
	        var filterDateEndRESULT = this.filterDateEndValue === '' ? filterDateStartRESULT : _lodash2.default.filter(filterDateStartRESULT, function (s) {
	          return s.createdAt <= new Date(_this2.filterDateEndValue).getTime() + 86399000;
	        });
	        var sortType = [];
	        var AorDESC = [];
	        _lodash2.default.forEach(this.currentSortOptions, function (value, key) {
	          if (value !== null) {
	            sortType.push(key);
	            AorDESC.push(value ? 'asc' : 'desc');
	          }
	        });
	
	
	        this.outputData = _lodash2.default.orderBy(filterDateEndRESULT, sortType, AorDESC);
	        return false;
	      } else {
	        return true;
	      }
	    },
	    totalPrice: function totalPrice() {
	      var su = 0;
	      _lodash2.default.forEach(this.outputData, function (o) {
	        su += o.price * 100000;
	      });
	
	      return su / 100000;
	    },
	    pageStart: function pageStart() {
	      return (this.currentPage - 1) * this.countOfPage;
	    },
	    filterCollection: function filterCollection() {
	      var filterTypeValue = this.filterTypeValue,
	          filterModelValue = this.filterModelValue,
	          filterDateStartValue = this.filterDateStartValue,
	          filterDateEndValue = this.filterDateEndValue;
	
	      return {
	        filterTypeValue: filterTypeValue, filterModelValue: filterModelValue, filterDateStartValue: filterDateStartValue, filterDateEndValue: filterDateEndValue
	      };
	    }
	  },
	  ready: function ready() {},
	
	  methods: {
	    download: function download() {
	      var csvTitles = ['Time', 'Type', 'Source MAC', 'Vendor', 'To', 'Price (€)'];
	      var dataKeys = ['createdAt', 'type', 'mac', 'from', 'to', 'price'];
	      var csvContent = csvTitles.join() + '\r\n';
	      var csvToDown = this.outputData;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var column = _step.value;
	
	          var columnData = dataKeys.map(function (k) {
	            if (k === 'createdAt') {
	              return (0, _moment2.default)(column[k]).format('YYYY-M-D h:mm:ss a');
	            } else {
	              return column[k];
	            }
	          });
	          csvContent = csvContent + columnData.join() + '\r\n';
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(csvToDown), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      csvContent += ',,,,,\r\n';
	      csvContent += ',,,,Total Amount: ' + this.outputData.length + ',Total Price: ' + this.totalPrice;
	      var textFileAsBlob = new window.Blob([csvContent], { type: 'text/plain' });
	      var atag = this.$els.download;
	      atag.download = 'exportLog.csv';
	      atag.href = window.URL.createObjectURL(textFileAsBlob);
	      try {
	        console.log('a click', textFileAsBlob);
	        atag.click();
	      } catch (e) {
	        window.navigator.msSaveBlob(textFileAsBlob, 'exportLog.csv');
	      }
	    },
	    sortBy: function sortBy(type) {
	      var currentSortOptions = this.currentSortOptions;
	
	      switch (currentSortOptions[type]) {
	        case null:
	          currentSortOptions[type] = true;
	          break;
	        case false:
	          currentSortOptions[type] = null;
	          break;
	        case true:
	          currentSortOptions[type] = false;
	          break;
	      }
	    },
	    sortIconCreator: function sortIconCreator(colName, sorType) {
	      var icon = {
	        'alphabet': 'glyphicon-sort-by-alphabet',
	        'order': 'glyphicon-sort-by-order',
	        'attribute': 'glyphicon-sort-by-attributes'
	      };
	      var currentSortOptions = this.currentSortOptions;
	
	      return currentSortOptions[colName] !== null ? currentSortOptions[colName] ? icon[sorType] : icon[sorType] + '-alt' : 'glyphicon-sort sort_default';
	    },
	    typeClassCreator: function typeClassCreator(type) {
	      switch (type) {
	        case 'delete':
	          return 'btn-danger';
	        case 'create':
	          return 'btn-success';
	        case 'update':
	          return 'btn-info';
	      }
	    }
	  },
	  watch: {
	    filterCollection: {
	      deep: true,
	      handler: function handler(nv) {
	        this.currentPage = 1;
	        this.currPaginationSec = 1;
	      }
	    }
	  }
	};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(33);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(221);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(51);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(31);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueStrap = __webpack_require__(16);
	
	var _Pagination = __webpack_require__(29);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _LinedTable = __webpack_require__(305);
	
	var _LinedTable2 = _interopRequireDefault(_LinedTable);
	
	var _index = __webpack_require__(7);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fb = (0, _index.getFireBase)();
	var PI = 'smart-controller';
	var SWITCH_CATEGORY = _index.filterOptions.firmware.category;
	var PI_CATEGORY = [{ label: 'Smart-controller', value: PI }];
	var PI_CUSTOM = [{ label: 'Gomax', value: 'gomax' }, { label: 'Gofanco', value: 'gofanco' }];
	var SWITCH_CUSTOM = _index.filterOptions.firmware.custom;
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    pagination: _Pagination2.default,
	    'v-select': _vueStrap.select,
	    'line-table': _LinedTable2.default
	  },
	  vuex: {
	    getters: {
	      user: function user(state) {
	        return state.user;
	      },
	      firmwareInfo: function firmwareInfo(state) {
	        return state.firmware;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      dynamicTitle: '',
	      countOfPage: 100,
	      currPage: 1,
	      countOfPagination: 5,
	      currPaginationSec: 1,
	      sortMethod: {
	        name: 'createdAt',
	        asc: false
	      },
	      postFix: {
	        all: '',
	        ite: 'i',
	        aspeed: 'a'
	      },
	      category: [],
	      selectedCategory: PI,
	      selectedCustom: 'gomax',
	      selectedStatus: 'dev',
	      selectedDomain: 'intri',
	      selectedModel: 'all',
	      version: '',
	      customOpts: [],
	      domainOpts: [],
	      modelOpts: [],
	      url: '',
	      testReportUrl: '',
	      feature: '',
	      bugFixed: '',
	      showModal: false,
	      modalTitle: '',
	      okText: '',
	      modalCb: function modalCb() {},
	      editingKey: '',
	      editingCategory: '',
	      showDeleteConfirm: false,
	      status: _index.filterOptions.firmware.status,
	      logFilter: {
	        custom: {
	          opts: [],
	          value: 'any'
	        },
	        date: {
	          opts: [{ label: 'Any', value: 'any' }, { label: '1 month', value: 'month' }],
	          value: 'any'
	        },
	        category: {
	          opts: [],
	          value: 'any'
	        },
	        domain: {
	          opts: [{ label: 'Any', value: 'any' }, { label: 'Intri', value: 'intri' }, { label: 'Eagleyes', value: 'eagleyes' }, { label: 'EvoIP', value: 'evoip' }, { label: 'AV Media', value: 'avmedia' }],
	          value: 'any'
	        },
	        model: {
	          opts: [{ label: 'Any', value: 'any' }, { label: 'ITE', value: 'ite' }, { label: 'ASPEED', value: 'aspeed' }],
	          value: 'any'
	        }
	      },
	      isUpdate: false,
	      isUpdatedAt: '',
	      versionPlaceholder: 'V1.10.1',
	      showInvalidMsg: false,
	      md5: ''
	    };
	  },
	  ready: function ready() {
	    var optAny = { label: 'Any', value: 'any' };
	    if (this.$route.name !== PI) {
	      this.dynamicTitle = 'Switch Firmware Change Log';
	      this.category = _lodash2.default.cloneDeep(SWITCH_CATEGORY);
	      this.selectedCategory = 'swix1';
	      this.logFilter.category.opts = _lodash2.default.cloneDeep(SWITCH_CATEGORY);
	      this.logFilter.category.opts.unshift(optAny);
	      this.logFilter.custom.opts = _lodash2.default.cloneDeep(SWITCH_CUSTOM);
	      this.logFilter.custom.opts.unshift(optAny);
	      this.selectedCustom = 'lantech';
	      this.customOpts = SWITCH_CUSTOM;
	      this.selectedModel = 'all';
	    } else {
	      this.dynamicTitle = 'Smart-Controller Firmware Change Log';
	      this.category = _lodash2.default.cloneDeep(PI_CATEGORY);
	      this.selectedCategory = PI;
	      this.logFilter.category.opts = _lodash2.default.cloneDeep(PI_CATEGORY);
	      this.logFilter.category.opts.unshift(optAny);
	      this.logFilter.custom.opts = _lodash2.default.cloneDeep(PI_CUSTOM);
	      this.logFilter.custom.opts.unshift(optAny);
	      this.selectedCustom = 'gomax';
	      this.customOpts = PI_CUSTOM;
	      this.selectedModel = 'ite';
	      this.modelOpts = [{ label: 'ITE', value: 'ite' }, { label: 'ASPEED', value: 'aspeed' }];
	      this.selectedDomain = 'intri';
	      this.domainOpts = [{ label: 'Intri', value: 'intri' }, { label: 'Eagleyes', value: 'eagleyes' }, { label: 'EvoIP', value: 'evoip' }, { label: 'AV Media', value: 'avmedia' }];
	    }
	    this.logFilter.category.value = this.firmwareInfo.category !== '' ? _lodash2.default.find(this.logFilter.category.opts, { label: this.firmwareInfo.category }).value : 'any';
	    this.logFilter.custom.value = this.firmwareInfo.custom !== '' ? _lodash2.default.find(this.customOpts, { label: this.firmwareInfo.custom }).value : 'any';
	    this.logFilter.date.value = 'any';
	    _index.store.dispatch('firmwareInfoDelete');
	  },
	  firebase: function firebase() {
	    return {
	      firmware: (0, _index.getFirmwareRef)(),
	      switch: (0, _index.getFwSwitchRef)().orderByChild('updatedAt'),
	      pi: (0, _index.getFWPiRef)().orderByChild('updatedAt')
	    };
	  },
	
	  computed: {
	    pageStart: function pageStart() {
	      return (this.currPage - 1) * this.countOfPage;
	    },
	    sortMethodOpts: function sortMethodOpts() {
	      if (this.$route.name === PI) {
	        return [{
	          label: 'Sort by Release Date',
	          value: 'createdAt'
	        }, {
	          label: 'Sort by Update Time',
	          value: 'updatedAt'
	        }, {
	          label: 'Sort by Category',
	          value: 'category'
	        }, {
	          label: 'Sort by Version',
	          value: 'version'
	        }, {
	          label: 'Sort by Domain',
	          value: 'domain'
	        }, {
	          label: 'Sort by Model',
	          value: 'model'
	        }, {
	          label: 'Sort by Custom',
	          value: 'custom'
	        }];
	      } else {
	        return [{
	          label: 'Sort by Release Date',
	          value: 'createdAt'
	        }, {
	          label: 'Sort by Update Time',
	          value: 'updatedAt'
	        }, {
	          label: 'Sort by Category',
	          value: 'category'
	        }, {
	          label: 'Sort by Version',
	          value: 'version'
	        }];
	      }
	    },
	    totalLength: function totalLength() {
	      return this.customFilteredTotalLog.length;
	    },
	    totalLog: function totalLog() {
	      var _sortMethod = this.sortMethod,
	          name = _sortMethod.name,
	          isAsc = _sortMethod.asc;
	
	      var data = this.$route.name === PI ? this.pi : this.switch;
	      if (name === 'version') {
	        return (0, _index.naturalSorting)(data, 'version', isAsc ? 'asc' : 'desc');
	      } else {
	        return _lodash2.default.orderBy(data, [name], [isAsc ? 'asc' : 'desc']);
	      }
	    },
	    dateFilteredTotalLog: function dateFilteredTotalLog() {
	      var _this = this;
	
	      return this.totalLog.filter(function (p) {
	        return _this.logFilter.date.value !== 'any' ? (0, _moment2.default)(p.updatedAt).isBetween((0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()) : true;
	      });
	    },
	    categoryFilteredTotalLog: function categoryFilteredTotalLog() {
	      var _this2 = this;
	
	      return this.dateFilteredTotalLog.filter(function (p) {
	        return _this2.logFilter.category.value !== 'any' ? p.category === _this2.logFilter.category.value : true;
	      });
	    },
	    domainFilteredTotalLog: function domainFilteredTotalLog() {
	      var _this3 = this;
	
	      return this.categoryFilteredTotalLog.filter(function (p) {
	        return _this3.logFilter.domain.value !== 'any' ? p.domain === _this3.logFilter.domain.value : true;
	      });
	    },
	    modelFilteredTotalLog: function modelFilteredTotalLog() {
	      var _this4 = this;
	
	      return this.domainFilteredTotalLog.filter(function (p) {
	        return _this4.logFilter.model.value !== 'any' ? p.model === _this4.logFilter.model.value : true;
	      });
	    },
	    statusFilteredTotalLog: function statusFilteredTotalLog() {
	      switch (this.user.role) {
	        case 'admin':
	          return this.modelFilteredTotalLog;
	        default:
	          return this.modelFilteredTotalLog.filter(function (p) {
	            return p.status !== 'dev';
	          });
	      }
	    },
	    customFilteredTotalLog: function customFilteredTotalLog() {
	      var _this5 = this;
	
	      if (!(typeof this.user.custom === 'undefined' && typeof this.user.role === 'undefined')) {
	        switch (this.user.role) {
	          case 'admin':
	          case 'vendor':
	            break;
	          case 'client':
	            this.logFilter.custom.opts = _lodash2.default.filter(this.logFilter.custom.opts, function (obj) {
	              return obj.value === 'any' || obj.value.toLowerCase() === 'lantech' || obj.value.toLowerCase() === _this5.user.custom.toLowerCase();
	            });
	            break;
	          default:
	            this.logFilter.custom.opts = _lodash2.default.filter(this.logFilter.custom.opts, function (obj) {
	              return obj.value === 'any';
	            });
	            break;
	        }
	      }
	      return this.statusFilteredTotalLog.filter(function (p) {
	        return _this5.logFilter.custom.value !== 'any' ? p.custom === _this5.logFilter.custom.value : typeof _lodash2.default.find(_this5.logFilter.custom.opts, { value: p.custom }) !== 'undefined';
	      });
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    handleDownload: function handleDownload(url, e) {
	      window.open(url);
	    },
	
	    getModelForUI: _index.getModelForUI,
	    getCustomForUI: _index.getCustomForUI,
	    getSmartControllerClass: function getSmartControllerClass(model) {
	      switch (model) {
	        case 'ite':
	          return 'ite_color_bg';
	        case 'aspeed':
	          return 'aspeed_color_bg';
	        case 'default':
	          return 'base_black base_grey_bg';
	      }
	    },
	    getIconSrc: function getIconSrc(category) {
	      return {
	        'smart-controller': '/static/svg/smart_controller.svg',
	        'swix1': '/static/svg/core1.svg',
	        'swix2': '/static/svg/core2.svg',
	        'wrouter': '/static/svg/ap.svg',
	        'router': '/static/svg/router.svg',
	        'routerx': '/static/svg/routerx.svg'
	      }[category];
	    },
	    handleShowModal: function handleShowModal(which, key, index) {
	      console.log('key', key);
	
	
	      this.editingKey = key;
	      if (which === 'upload') {
	        this.modalTitle = 'Add firmware';
	        this.isUpdate = false;
	        this.okText = 'Add';
	        this.bugFixed = '';
	        this.feature = '';
	        this.version = '';
	        this.url = '';
	        this.testReportUrl = '';
	        this.modalCb = this.applyUpload;
	        this.md5 = '';
	      } else if (which === 'update') {
	        this.modalTitle = 'Edit firmware';
	        this.isUpdate = true;
	        var _customFilteredTotalL = this.customFilteredTotalLog[index + this.pageStart],
	            _customFilteredTotalL2 = _customFilteredTotalL.updatedAt,
	            updatedAt = _customFilteredTotalL2 === undefined ? '' : _customFilteredTotalL2,
	            _customFilteredTotalL3 = _customFilteredTotalL.bugFixed,
	            bugFixed = _customFilteredTotalL3 === undefined ? '' : _customFilteredTotalL3,
	            _customFilteredTotalL4 = _customFilteredTotalL.feature,
	            feature = _customFilteredTotalL4 === undefined ? '' : _customFilteredTotalL4,
	            version = _customFilteredTotalL.version,
	            url = _customFilteredTotalL.url,
	            _customFilteredTotalL5 = _customFilteredTotalL.testReportUrl,
	            testReportUrl = _customFilteredTotalL5 === undefined ? '' : _customFilteredTotalL5,
	            _customFilteredTotalL6 = _customFilteredTotalL.domain,
	            domain = _customFilteredTotalL6 === undefined ? '' : _customFilteredTotalL6,
	            model = _customFilteredTotalL.model,
	            custom = _customFilteredTotalL.custom,
	            category = _customFilteredTotalL.category,
	            status = _customFilteredTotalL.status,
	            _customFilteredTotalL7 = _customFilteredTotalL.md5,
	            md5 = _customFilteredTotalL7 === undefined ? '' : _customFilteredTotalL7;
	
	        this.isUpdatedAt = '';
	        this.isUpdatedAt = (0, _moment2.default)(updatedAt).format('YYYYMMDD HH:mm:ss');
	        this.bugFixed = bugFixed;
	        this.feature = feature;
	        this.selectedCategory = category;
	        this.selectedDomain = domain;
	        this.selectedModel = model;
	        this.selectedCustom = custom;
	        this.selectedStatus = status;
	        this.url = url;
	        this.testReportUrl = testReportUrl;
	        this.okText = 'Update';
	        this.modalCb = this.applyUpdate;
	        this.version = version;
	        this.md5 = md5;
	      }
	      this.showModal = true;
	    },
	    handleShowDeleteConfirm: function handleShowDeleteConfirm(key, category) {
	      this.editingKey = key;
	      this.editingCategory = category;
	      this.showDeleteConfirm = true;
	    },
	    isVersionValid: function isVersionValid() {
	      if (this.selectedModel === 'ite') {
	        return this.version.startsWith('sciV');
	      } else if (this.selectedModel === 'aspeed') {
	        return this.version.startsWith('scaV');
	      } else {
	        return true;
	      }
	    },
	    applyUpload: function applyUpload() {
	      this.showInvalidMsg = false;
	      var key = '';
	      if (this.$route.name !== PI) {
	        key = 'switch';
	        this.selectedModel = 'all';
	      } else {
	        key = 'pi';
	        if (!this.isVersionValid()) {
	          this.showInvalidMsg = true;
	          this.alert('danger', '', 'Invalid version');
	          return;
	        }
	      }
	      var toPush = {
	        createdAt: fb.database.ServerValue.TIMESTAMP,
	        domain: this.selectedDomain,
	        model: this.selectedModel,
	        url: this.url,
	        testReportUrl: this.testReportUrl,
	        version: this.version,
	        status: this.selectedStatus,
	        feature: this.feature,
	        bugFixed: this.bugFixed,
	        custom: this.selectedCustom,
	        updatedAt: fb.database.ServerValue.TIMESTAMP,
	        category: this.selectedCategory,
	        md5: this.md5
	      };
	      this.$firebaseRefs[key].push(toPush);
	      this.showModal = false;
	    },
	    applyUpdate: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _this6 = this;
	
	        var key, createdAt, update;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                key = '';
	
	                if (!(this.selectedCategory !== PI)) {
	                  _context.next = 6;
	                  break;
	                }
	
	                this.selectedModel = 'all';
	                key = 'switch';
	                _context.next = 11;
	                break;
	
	              case 6:
	                key = 'pi';
	
	                if (this.isVersionValid()) {
	                  _context.next = 11;
	                  break;
	                }
	
	                this.showInvalidMsg = true;
	                this.alert('danger', '', 'Invalid version');
	                return _context.abrupt('return');
	
	              case 11:
	                createdAt = '';
	                _context.next = 14;
	                return this.$firebaseRefs[key].once('value').then(function (snapshot) {
	                  var snap = snapshot.val();
	                  var _iteratorNormalCompletion = true;
	                  var _didIteratorError = false;
	                  var _iteratorError = undefined;
	
	                  try {
	                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(snap)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                      var i = _step.value;
	
	                      if (i === _this6.editingKey) {
	                        createdAt = snap[i].createdAt;
	                        break;
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	                    } finally {
	                      if (_didIteratorError) {
	                        throw _iteratorError;
	                      }
	                    }
	                  }
	                });
	
	              case 14:
	                update = {};
	
	                update[this.editingKey] = {
	                  createdAt: createdAt,
	                  updatedAt: fb.database.ServerValue.TIMESTAMP,
	                  domain: this.selectedDomain,
	                  model: this.selectedModel,
	                  custom: this.selectedCustom,
	                  url: this.url,
	                  testReportUrl: this.testReportUrl,
	                  version: this.version,
	                  status: this.selectedStatus,
	                  feature: this.feature,
	                  bugFixed: this.bugFixed,
	                  category: this.selectedCategory,
	                  md5: this.md5
	                };
	                this.$firebaseRefs[key].update(update);
	                this.showModal = false;
	
	              case 18:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function applyUpdate() {
	        return _ref.apply(this, arguments);
	      }
	
	      return applyUpdate;
	    }(),
	    applyDelete: function applyDelete() {
	      if (this.editingCategory !== PI) {
	        this.$firebaseRefs.switch.child(this.editingKey).remove();
	      } else {
	        this.$firebaseRefs.pi.child(this.editingKey).remove();
	      }
	      this.showDeleteConfirm = false;
	    }
	  },
	  watch: {
	    logFilter: {
	      deep: true,
	      handler: function handler(nv) {
	        this.currPage = 1;
	        this.currPaginationSec = 1;
	      }
	    },
	    selectedModel: function selectedModel(nv) {
	      switch (nv) {
	        case 'all':
	          this.versionPlaceholder = 'V1.10.1';
	          break;
	        case 'ite':
	          this.versionPlaceholder = 'sciV1.10.1';
	          if (!this.version.startsWith('sciV') && !this.isUpdate) this.version = '';
	          break;
	        case 'aspeed':
	          this.versionPlaceholder = 'scaV1.10.1';
	          if (!this.version.startsWith('scaV') && !this.isUpdate) this.version = '';
	          break;
	      }
	    }
	  },
	  route: {
	    canReuse: false, activate: function activate(_ref2) {
	      var next = _ref2.next;
	
	      next();
	    }
	  }
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(29);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _index = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    pagination: _Pagination2.default
	  },
	  data: function data() {
	    return {
	      snFilter: '',
	      countOfPage: 10,
	      currPage: 1,
	      countOfPagination: 5,
	      currPaginationSec: 1
	    };
	  },
	
	  vuex: {
	    getters: {
	      user: function user(state) {
	        return state.user;
	      }
	    }
	  },
	  computed: {
	    filteredLog: function filteredLog() {
	      var _this = this;
	
	      return this[this.$route.name].filter(function (f) {
	        return f.sn.indexOf(_this.snFilter) !== -1;
	      });
	    },
	    totalLength: function totalLength() {
	      return this[this.$route.name].length;
	    },
	    pageStart: function pageStart() {
	      return (this.currPage - 1) * this.countOfPage;
	    }
	  },
	  methods: {
	    deleteUpgHis: function deleteUpgHis(key) {
	      if (key == null) {
	        return;
	      }
	      if (this.user.role === 'admin') {
	        (0, _index.getSmartCtrlHistory)().child(key).remove();
	      }
	    }
	  },
	  firebase: function firebase() {
	    return {
	      'smart-controller': (0, _index.getSmartCtrlHistory)(),
	      switch: (0, _index.getSwitchHistory)()
	    };
	  },
	  ready: function ready() {
	    console.log('filterd Log is:', this.$route.name);
	  },
	
	  watch: {
	    snFilter: {
	      handler: function handler(nv) {
	        this.currPage = 1;
	        this.currPaginationSec = 1;
	      }
	    }
	  }
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'IntriHub'
	    };
	  },
	  ready: function ready() {}
	};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(33);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(31);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _index = __webpack_require__(7);
	
	var Service = _interopRequireWildcard(_index);
	
	var _vueStrap = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal
	  },
	  data: function data() {
	    return {
	      account:  true ? '' : 'kenlee@intrising.com.tw',
	      password:  true ? '' : '53116727',
	      newUser: {
	        email: '',
	        pwd: '',
	        confirmPwd: ''
	      },
	      forgottenMail: '',
	      showNewAccount: false,
	      showForgetPw: false,
	      showMailHint: false,
	      showMailResend: false,
	      emailResendTarget: null
	    };
	  },
	  vuex: {
	    getters: {
	      user: function user(state) {
	        return state.user;
	      }
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    login: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var loginRes;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return Service.login(this.account, this.password);
	
	              case 3:
	                loginRes = _context.sent;
	
	                console.log(loginRes);
	                this.$router.replace('/');
	                _context.next = 12;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context['catch'](0);
	
	                console.log(_context.t0);
	                this.alert('danger', 'Login Fail', _context.t0);
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 8]]);
	      }));
	
	      function login() {
	        return _ref.apply(this, arguments);
	      }
	
	      return login;
	    }(),
	    resendMail: function resendMail() {
	      this.emailResendTarget.sendEmailVerification();
	      this.showMailResend = false;
	    },
	    closeDialogs: function closeDialogs() {
	      this.showMailHint = false;
	      this.showMailResend = false;
	    },
	    handleNewAccount: function handleNewAccount() {
	      var _this = this;
	
	      if (this.$newAccValidator.newemail.valid) {
	        if (this.newUser.pwd !== this.newUser.confirmPwd) {
	          this.alert('danger', 'Error', 'Two passwords must be same.');
	        } else {
	          Service.createUser(this.newUser.email, this.newUser.pwd).then(function (userCredential) {
	            console.log(userCredential);
	            userCredential.sendEmailVerification();
	            _this.account = _this.newUser.email;
	            _this.password = '';
	            _this.showNewAccount = false;
	            _this.showMailHint = true;
	          }).catch(function (err) {
	            _this.alert('danger', 'Error', err.message);
	          });
	        }
	      } else {
	        this.alert('danger', 'Error', 'Please enter a valid email address');
	      }
	    },
	    handleForget: function handleForget() {
	      var _this2 = this;
	
	      if (this.$forgetPw.email.valid) {
	        Service.resetPassword(this.forgottenMail).then(function (res) {
	          console.log(res);
	          _this2.showForgetPw = false;
	          _this2.alert('success', '', 'Your password has been reset successfully. Please check your email for more detail.');
	        }).catch(function (err) {
	          console.log(err);
	          _this2.alert('danger', 'Error', err);
	        });
	      } else {
	        return this.alert('danger', 'Error', 'Please enter a valid email address');
	      }
	    }
	  },
	  watch: {
	    showNewAccount: function showNewAccount(show) {
	      if (show) {
	        this.newUser.email = '';
	        this.newUser.pwd = '';
	        this.newUser.confirmPwd = '';
	      }
	    },
	    showForgetPw: function showForgetPw(show) {
	      if (show) {
	        this.forgottenMail = '';
	      }
	    }
	  },
	  ready: function ready() {
	    console.log('ready');
	  }
	};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _index = __webpack_require__(7);
	
	var _Pagination = __webpack_require__(29);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _vueStrap = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'bs-input': _vueStrap.input,
	    dropdown: _vueStrap.dropdown,
	    pagination: _Pagination2.default,
	    modal: _vueStrap.modal,
	    'v-select': _vueStrap.select
	  },
	  data: function data() {
	    return {
	      countOfPage: 10,
	      currPage: 1,
	      countOfPagination: 5,
	      currPaginationSec: 1,
	
	      modalStatus: false,
	      modalPurpose: null,
	      modalMethod: null,
	      modalTitle: 'Hello',
	      modalSize: {
	        large: false,
	        small: false
	      },
	      modalData: [],
	
	      searchBar: {
	        opts: [{
	          label: 'Serial Number',
	          value: '.key'
	        }, {
	          label: 'Mac',
	          value: 'mac'
	        }],
	        value: '.key'
	      },
	      searchContent: ''
	    };
	  },
	  ready: function ready() {},
	  firebase: function firebase() {
	    return {
	      pi: (0, _index.getSmartCtrlRef)()
	    };
	  },
	
	  computed: {
	    pageStart: function pageStart() {
	      return (this.currPage - 1) * this.countOfPage;
	    },
	    outputData: function outputData() {
	      var pi = this.pi;
	
	      var searchColumn = this.searchBar.value;
	      var searchContent = this.searchContent;
	      return pi.filter(function (p) {
	        return searchContent !== '' ? _lodash2.default.includes(_lodash2.default.toLower(p[searchColumn]), _lodash2.default.toLower(searchContent)) : true;
	      });
	    }
	  },
	  methods: {
	    closeModal: function closeModal() {
	      this.modalStatus = false;
	    },
	    deleteData: function deleteData() {
	      var targetKey = this.modalData['.key'];
	      this.$firebaseRefs.pi.child(targetKey).remove();
	      this.closeModal();
	    },
	    saveEdittedData: function saveEdittedData() {
	      var key = this.modalData['.key'];
	
	      var _modalData = (0, _extends3.default)({}, this.modalData),
	          domain = _modalData.domain,
	          model = _modalData.model,
	          fwVersion = _modalData.fwVersion;
	
	      this.$firebaseRefs.pi.child(key).update({ domain: domain, model: model, fwVersion: fwVersion });
	      this.closeModal();
	    },
	    showDeleteConfirm: function showDeleteConfirm(targetKey) {
	      this.modalPurpose = 'deleteConfirm';
	      this.modalMethod = 'confirm';
	      this.modalTitle = 'Warning!';
	      this.modalData = targetKey;
	      this.modalStatus = true;
	    },
	    showEditForm: function showEditForm(originalData) {
	      this.modalPurpose = 'edit';
	      this.modalMethod = 'edit';
	      this.modalTitle = 'Edit Production';
	      this.modalData = (0, _extends3.default)({}, originalData);
	      this.modalStatus = true;
	    }
	  }
	};

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	module.exports = {"name":"controller-hub","version":"2.0.1","description":"A Vue.js project","author":"ccboys <walter@intrising.com.tw>","private":true,"scripts":{"dev":"node build/dev-server.js","build":"node build/build.js","__unit":"karma start test/unit/karma.conf.js --single-run","deploy-functions":"npm run --prefix ./functions build && firebase deploy --only functions","deploy-hosting":"npm run build && firebase deploy --only hosting","unit":"eslint test/server && mocha test/server --compilers js:babel-core/register -t 5000","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"babel-runtime":"^6.0.0","firebase":"^4.4.0","firebase-admin":"^5.2.1","firebase-functions":"^0.6.3","pug":"^2.0.0-beta11","sass-loader":"^6.0.3","vue":"^1.0.21","vue-router":"^0.7.13","vue-validator":"2","vuex":"1"},"devDependencies":{"babel-core":"^6.0.0","babel-eslint":"^6.1.2","babel-loader":"^6.0.0","babel-plugin-transform-runtime":"^6.0.0","babel-preset-es2015":"^6.0.0","babel-preset-stage-2":"^6.0.0","babel-register":"^6.0.0","bootstrap":"^3.3.7","chai":"^3.5.0","chromedriver":"^2.21.2","connect-history-api-fallback":"^1.1.0","cross-spawn":"^2.1.5","css-loader":"^0.23.0","eslint":"^2.10.2","eslint-config-standard":"^5.1.0","eslint-friendly-formatter":"^2.0.5","eslint-loader":"^1.3.0","eslint-plugin-html":"^1.3.0","eslint-plugin-promise":"^1.0.8","eslint-plugin-standard":"^1.3.2","eventsource-polyfill":"^0.9.6","express":"^4.13.3","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.8.4","font-awesome":"^4.7.0","function-bind":"^1.0.2","html-webpack-plugin":"^2.8.1","http-proxy-middleware":"^0.12.0","inject-loader":"^2.0.1","isparta-loader":"^2.0.0","json-loader":"^0.5.4","karma":"^0.13.15","karma-coverage":"^0.5.5","karma-mocha":"^0.2.2","karma-phantomjs-launcher":"^1.0.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.24","karma-webpack":"^1.7.0","lodash":"^4.17.4","lolex":"^1.4.0","mocha":"^2.4.5","moment":"^2.18.1","nightwatch":"^0.8.18","node-sass":"^4.5.1","ora":"^0.2.0","phantomjs-prebuilt":"^2.1.3","selenium-server":"2.53.0","shelljs":"^0.6.0","should":"^11.2.1","sinon":"^1.17.3","sinon-chai":"^2.8.0","supertest":"^3.0.0","url-loader":"^0.5.7","vue-hot-reload-api":"^1.2.0","vue-html-loader":"^1.0.0","vue-loader":"^8.3.0","vue-strap":"1.1.36","vue-style-loader":"^1.0.0","vuefire":"^1.4.0","webpack":"^1.12.2","webpack-dev-middleware":"^1.4.0","webpack-hot-middleware":"^2.6.0","webpack-merge":"^0.8.3"}}

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 73,
		"./af.js": 73,
		"./ar": 80,
		"./ar-dz": 74,
		"./ar-dz.js": 74,
		"./ar-kw": 75,
		"./ar-kw.js": 75,
		"./ar-ly": 76,
		"./ar-ly.js": 76,
		"./ar-ma": 77,
		"./ar-ma.js": 77,
		"./ar-sa": 78,
		"./ar-sa.js": 78,
		"./ar-tn": 79,
		"./ar-tn.js": 79,
		"./ar.js": 80,
		"./az": 81,
		"./az.js": 81,
		"./be": 82,
		"./be.js": 82,
		"./bg": 83,
		"./bg.js": 83,
		"./bm": 84,
		"./bm.js": 84,
		"./bn": 85,
		"./bn.js": 85,
		"./bo": 86,
		"./bo.js": 86,
		"./br": 87,
		"./br.js": 87,
		"./bs": 88,
		"./bs.js": 88,
		"./ca": 89,
		"./ca.js": 89,
		"./cs": 90,
		"./cs.js": 90,
		"./cv": 91,
		"./cv.js": 91,
		"./cy": 92,
		"./cy.js": 92,
		"./da": 93,
		"./da.js": 93,
		"./de": 96,
		"./de-at": 94,
		"./de-at.js": 94,
		"./de-ch": 95,
		"./de-ch.js": 95,
		"./de.js": 96,
		"./dv": 97,
		"./dv.js": 97,
		"./el": 98,
		"./el.js": 98,
		"./en-au": 99,
		"./en-au.js": 99,
		"./en-ca": 100,
		"./en-ca.js": 100,
		"./en-gb": 101,
		"./en-gb.js": 101,
		"./en-ie": 102,
		"./en-ie.js": 102,
		"./en-il": 103,
		"./en-il.js": 103,
		"./en-nz": 104,
		"./en-nz.js": 104,
		"./eo": 105,
		"./eo.js": 105,
		"./es": 108,
		"./es-do": 106,
		"./es-do.js": 106,
		"./es-us": 107,
		"./es-us.js": 107,
		"./es.js": 108,
		"./et": 109,
		"./et.js": 109,
		"./eu": 110,
		"./eu.js": 110,
		"./fa": 111,
		"./fa.js": 111,
		"./fi": 112,
		"./fi.js": 112,
		"./fo": 113,
		"./fo.js": 113,
		"./fr": 116,
		"./fr-ca": 114,
		"./fr-ca.js": 114,
		"./fr-ch": 115,
		"./fr-ch.js": 115,
		"./fr.js": 116,
		"./fy": 117,
		"./fy.js": 117,
		"./gd": 118,
		"./gd.js": 118,
		"./gl": 119,
		"./gl.js": 119,
		"./gom-latn": 120,
		"./gom-latn.js": 120,
		"./gu": 121,
		"./gu.js": 121,
		"./he": 122,
		"./he.js": 122,
		"./hi": 123,
		"./hi.js": 123,
		"./hr": 124,
		"./hr.js": 124,
		"./hu": 125,
		"./hu.js": 125,
		"./hy-am": 126,
		"./hy-am.js": 126,
		"./id": 127,
		"./id.js": 127,
		"./is": 128,
		"./is.js": 128,
		"./it": 129,
		"./it.js": 129,
		"./ja": 130,
		"./ja.js": 130,
		"./jv": 131,
		"./jv.js": 131,
		"./ka": 132,
		"./ka.js": 132,
		"./kk": 133,
		"./kk.js": 133,
		"./km": 134,
		"./km.js": 134,
		"./kn": 135,
		"./kn.js": 135,
		"./ko": 136,
		"./ko.js": 136,
		"./ky": 137,
		"./ky.js": 137,
		"./lb": 138,
		"./lb.js": 138,
		"./lo": 139,
		"./lo.js": 139,
		"./lt": 140,
		"./lt.js": 140,
		"./lv": 141,
		"./lv.js": 141,
		"./me": 142,
		"./me.js": 142,
		"./mi": 143,
		"./mi.js": 143,
		"./mk": 144,
		"./mk.js": 144,
		"./ml": 145,
		"./ml.js": 145,
		"./mn": 146,
		"./mn.js": 146,
		"./mr": 147,
		"./mr.js": 147,
		"./ms": 149,
		"./ms-my": 148,
		"./ms-my.js": 148,
		"./ms.js": 149,
		"./mt": 150,
		"./mt.js": 150,
		"./my": 151,
		"./my.js": 151,
		"./nb": 152,
		"./nb.js": 152,
		"./ne": 153,
		"./ne.js": 153,
		"./nl": 155,
		"./nl-be": 154,
		"./nl-be.js": 154,
		"./nl.js": 155,
		"./nn": 156,
		"./nn.js": 156,
		"./pa-in": 157,
		"./pa-in.js": 157,
		"./pl": 158,
		"./pl.js": 158,
		"./pt": 160,
		"./pt-br": 159,
		"./pt-br.js": 159,
		"./pt.js": 160,
		"./ro": 161,
		"./ro.js": 161,
		"./ru": 162,
		"./ru.js": 162,
		"./sd": 163,
		"./sd.js": 163,
		"./se": 164,
		"./se.js": 164,
		"./si": 165,
		"./si.js": 165,
		"./sk": 166,
		"./sk.js": 166,
		"./sl": 167,
		"./sl.js": 167,
		"./sq": 168,
		"./sq.js": 168,
		"./sr": 170,
		"./sr-cyrl": 169,
		"./sr-cyrl.js": 169,
		"./sr.js": 170,
		"./ss": 171,
		"./ss.js": 171,
		"./sv": 172,
		"./sv.js": 172,
		"./sw": 173,
		"./sw.js": 173,
		"./ta": 174,
		"./ta.js": 174,
		"./te": 175,
		"./te.js": 175,
		"./tet": 176,
		"./tet.js": 176,
		"./tg": 177,
		"./tg.js": 177,
		"./th": 178,
		"./th.js": 178,
		"./tl-ph": 179,
		"./tl-ph.js": 179,
		"./tlh": 180,
		"./tlh.js": 180,
		"./tr": 181,
		"./tr.js": 181,
		"./tzl": 182,
		"./tzl.js": 182,
		"./tzm": 184,
		"./tzm-latn": 183,
		"./tzm-latn.js": 183,
		"./tzm.js": 184,
		"./ug-cn": 185,
		"./ug-cn.js": 185,
		"./uk": 186,
		"./uk.js": 186,
		"./ur": 187,
		"./ur.js": 187,
		"./uz": 189,
		"./uz-latn": 188,
		"./uz-latn.js": 188,
		"./uz.js": 189,
		"./vi": 190,
		"./vi.js": 190,
		"./x-pseudo": 191,
		"./x-pseudo.js": 191,
		"./yo": 192,
		"./yo.js": 192,
		"./zh-cn": 193,
		"./zh-cn.js": 193,
		"./zh-hk": 194,
		"./zh-hk.js": 194,
		"./zh-tw": 195,
		"./zh-tw.js": 195
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 290;


/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	module.exports = "<div class=clearfix id=app><navbar class=\"clearfix navbar navbar-default\" v-if=\"authed &amp;&amp; $route.path !== '/login'\" placement=top type=default><a class=navbar-brand slot=brand v-link=\"{name: 'index'}\"><span style=color:#ffcb2f>Controller</span><span>Hub</span></a><dropdown v-bind:class=\"{'active': $route.path.includes('smart-controller')}\" text=Smart-controller v-if=\"user.custom === 'all' || user.custom === 'gomax'\"><li v-bind:class=\"{'active': $route.path.includes('/smart-controller/production') &amp;&amp; !$route.path.includes('/smart-controller/production-activity')}\"><a v-link=\"{path: '/smart-controller/production'}\">Production</a></li><li v-bind:class=\"{'active': $route.path.includes('/smart-controller/production-activity')}\"><a v-link=\"{path: '/smart-controller/production-activity'}\" v-if=\"user.role === 'admin'\">Production Activity</a></li><li v-bind:class=\"{'active': $route.path.includes('/smart-controller/firmware')}\"><a v-link=\"{path: '/smart-controller/firmware'}\">Firmware</a></li><li v-bind:class=\"{'active': $route.path.includes('/smart-controller/history')}\"><a v-link=\"{path: '/smart-controller/history'}\">History</a></li></dropdown><dropdown v-bind:text=user.email slot=right><li><a @click=logout><i class=\"fa fa-sign-out\"></i>&nbsp;Logout</a></li><li><a>Ver. {{ version }}</a></li></dropdown></navbar><div class=main><router-view></router-view></div><alert v-bind:type=alertData.type v-bind:show.sync=alertData.show v-bind:duration=1000 width=280px placement=top-right dismissable=dismissable><span class=\"icon-ok-circled alert-icon-float-left\"></span><strong>{{ alertData.title }}</strong><p>{{ alertData.content }}</p></alert></div>";

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	module.exports = "<div class=container _v-0562dea6=\"\"><h1 class=main_title _v-0562dea6=\"\">Smart-controller Activity</h1><div class=loader v-if=dataLoading _v-0562dea6=\"\"></div><div class=\"col-md-12 function_bar\" v-else=v-else _v-0562dea6=\"\"><div _v-0562dea6=\"\"><label class=filter_label _v-0562dea6=\"\">Activity: </label><v-select v-bind:value.sync=filterTypeValue v-bind:options=filterTypeOpts placeholder=None _v-0562dea6=\"\"></v-select></div><div _v-0562dea6=\"\"><label class=filter_label _v-0562dea6=\"\">Model: </label><v-select v-bind:value.sync=filterModelValue v-bind:options=filterModelOpts placeholder=None _v-0562dea6=\"\"></v-select></div><div _v-0562dea6=\"\"><label class=filter_label _v-0562dea6=\"\">Start from:</label><input class=\"filter_option filter_date\" type=date v-model=filterDateStartValue v-bind:max=today _v-0562dea6=\"\"></div><div _v-0562dea6=\"\"><label class=filter_label _v-0562dea6=\"\">End at:</label><input class=filter_date type=date v-model=filterDateEndValue v-bind:min=filterDateStartValue v-bind:max=today _v-0562dea6=\"\"></div></div><div class=output_data_container v-if=\"outputData.length > 0\" _v-0562dea6=\"\"><pagination v-bind:count-of-page.sync=countOfPage v-bind:curr-page.sync=currentPage v-bind:count-of-pagination=countOfPagination v-bind:curr-pagination-sec.sync=currPaginationSec v-bind:target-ary.sync=outputData v-if=\"outputData.length > 10\" _v-0562dea6=\"\"></pagination><div class=\"col-md-12 no_pad\" _v-0562dea6=\"\"><table class=\"table table-hover table-bordered\" _v-0562dea6=\"\"><tbody _v-0562dea6=\"\"><tr _v-0562dea6=\"\"><th _v-0562dea6=\"\">Time<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('createdAt', 'attribute')\" @click=\"sortBy('createdAt')\" _v-0562dea6=\"\"></span></div></th><th _v-0562dea6=\"\">Activity<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('type', 'attribute')\" @click=\"sortBy('type')\" _v-0562dea6=\"\"></span></div></th><th _v-0562dea6=\"\">Serial Number<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('serialNum', 'alphabet')\" @click=\"sortBy('serialNum')\" _v-0562dea6=\"\"></span></div></th><th _v-0562dea6=\"\">MAC<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('data.mac', 'alphabet')\" @click=\"sortBy('data.mac')\" _v-0562dea6=\"\"></span></div></th><th _v-0562dea6=\"\">Model<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('data.model', 'alphabet')\" @click=\"sortBy('data.model')\" _v-0562dea6=\"\"></span></div></th><th _v-0562dea6=\"\">Version<div class=pull-right _v-0562dea6=\"\"><span class=glyphicon :class=\"sortIconCreator('data.fwVersion', 'attribute')\" @click=\"sortBy('data.fwVersion')\" _v-0562dea6=\"\"></span></div></th></tr><tr v-for=\"log in outputData | limitBy countOfPage pageStart\" _v-0562dea6=\"\"><td _v-0562dea6=\"\">{{ log.createdAt | timeFormat 'YYYY/MM/DD hh:mm:ss A' }}</td><td class=text-capitalize :class=typeClassCreator(log.type) _v-0562dea6=\"\">{{ log.type }} <span class=text-lowercase style=\"font-size: 8px\" _v-0562dea6=\"\">{{ log.type === 'update' ? `(from ${log.data.after.ip})` : ''}}</span></td><td _v-0562dea6=\"\">{{ log.serialNum }}</td><td v-if=\"log.type === 'update'\" _v-0562dea6=\"\">{{ log.data.after.mac }}</td><td v-else=v-else _v-0562dea6=\"\">{{ log.data.mac }}</td><td class=text-uppercase v-if=\"log.type === 'update'\" _v-0562dea6=\"\">{{ log.data.after.model }}</td><td class=text-uppercase v-else=v-else _v-0562dea6=\"\">{{ log.data.model }}</td><td v-if=\"log.type === 'update'\" _v-0562dea6=\"\">{{ log.data.after.fwVersion }}</td><td v-else=v-else _v-0562dea6=\"\">{{ log.data.fwVersion }}</td></tr></tbody></table></div></div><h2 class=\"text-center text-muted\" v-else=v-else _v-0562dea6=\"\">No Data</h2></div>";

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	module.exports = "<table class=release_note _v-3ef62982=\"\"><tbody _v-3ef62982=\"\"><tr _v-3ef62982=\"\"><td class=type _v-3ef62982=\"\">{{title}}</td></tr><tr v-if=!hasBr _v-3ef62982=\"\"><td class=content _v-3ef62982=\"\">{{computedContent}}</td></tr><tr v-for=\"($index, s) in computedContent\" track-by=$index v-else=v-else _v-3ef62982=\"\"><td class=content _v-3ef62982=\"\">{{s}}</td></tr></tbody></table>";

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	module.exports = "<div class=\"pagination_section col-md-12 col-sm-12\" style=\"display:inline-flex; justify-content: space-between; padding-left: 0; padding-right: 0; flex-wrap: wrap\" _v-5192821b=\"\"><div style=\"display:inline-flex; align-items: center; margin-top: 6px; margin-bottom: 6px\" v-if=\"sortMethodOpts.length > 0\" _v-5192821b=\"\"><v-select justified=justified close-on-select=close-on-select v-bind:value.sync=sortMethod.name v-bind:options=sortMethodOpts name=sortMethodName _v-5192821b=\"\"></v-select><button class=\"btn btn-default glyphicon\" style=\"margin-left: 8px; font-size: 18px; padding: 3px 8px\" :class=\"sortMethod.asc ? 'glyphicon-sort-by-attributes' : 'glyphicon-sort-by-attributes-alt'\" @click=sortBy() _v-5192821b=\"\"></button><strong style=\"display: inline-block; margin-left: 8px\" _v-5192821b=\"\">Total: {{ targetAry.length }}</strong></div><div v-else=v-else style=\"display:inline-flex; align-items: center; width: 182px; margin-top: 6px; margin-bottom: 6px\" _v-5192821b=\"\"><strong style=\"display: inline-block\" _v-5192821b=\"\">Total: {{ targetAry.length }}</strong></div><div class=btn-group v-if=\"targetAry.length > 10\" style=\"margin: 6px 12px 6px 0\" _v-5192821b=\"\"><button class=\"btn btn-default more\" @click=setPaginationSec(currPaginationSec-1) v-if=\"currPaginationSec !== 1\" _v-5192821b=\"\"><span class=\"glyphicon glyphicon-backward\" _v-5192821b=\"\"></span></button><button class=\"btn btn-default more\" @click.prevent=setPage(currPage-1) v-bind:class=\"{'disabled': (currPage === 1)}\" _v-5192821b=\"\"><span class=\"glyphicon glyphicon-triangle-left\" _v-5192821b=\"\"></span></button><button class=\"btn btn-default page\" @click.prevent=setPage(n+1) v-for=\"n in totalPageAry | limitBy countOfPagination paginationStart\" v-bind:class=\"{'active': (currPage === (n+1))}\" style=\"min-width: 43px\" _v-5192821b=\"\"> {{n+1}}</button><button class=\"btn btn-default more\" @click.prevent=setPage(currPage+1) v-bind:class=\"{'disabled': (currPage === totalPage)}\" _v-5192821b=\"\"><span class=\"glyphicon glyphicon-triangle-right\" _v-5192821b=\"\"></span></button><button class=\"btn btn-default more\" @click=setPaginationSec(currPaginationSec+1) v-if=\"currPaginationSec !== totalSection\" _v-5192821b=\"\"><span class=\"glyphicon glyphicon-forward\" _v-5192821b=\"\"></span></button></div><v-select style=\"margin-top: 6px; margin-bottom: 6px\" justified=justified close-on-select=close-on-select v-bind:value.sync=countOfPage v-bind:options=countOfPageOptions options-value=val name=countOfPage[] @change=resetPagination _v-5192821b=\"\"></v-select></div>";

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	module.exports = "<div class=\"container col-centered\" _v-6154f075=\"\"><div class=row _v-6154f075=\"\"><div class=col-xs-12 _v-6154f075=\"\"><h1 class=main_title _v-6154f075=\"\">{{dynamicTitle}}</h1></div><div class=\"col-xs-12 function_bar\" _v-6154f075=\"\"><div class=form-group _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Date:</label><v-select v-bind:value.sync=logFilter.date.value v-bind:options=logFilter.date.opts _v-6154f075=\"\"></v-select></div><div class=form-group _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Category:</label><v-select v-bind:value.sync=logFilter.category.value v-bind:options=logFilter.category.opts _v-6154f075=\"\"></v-select></div><div class=form-group v-if=\"$route.name === 'smart-controller'\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Domain:</label><v-select v-bind:value.sync=logFilter.domain.value v-bind:options=logFilter.domain.opts _v-6154f075=\"\"></v-select></div><div class=form-group v-if=\"$route.name === 'smart-controller'\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Model:</label><v-select v-bind:value.sync=logFilter.model.value v-bind:options=logFilter.model.opts _v-6154f075=\"\"></v-select></div><div class=form-group _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Custom:</label><v-select v-bind:value.sync=logFilter.custom.value v-bind:options=logFilter.custom.opts _v-6154f075=\"\"></v-select></div><div class=upload _v-6154f075=\"\"><button class=\"btn btn-primary\" v-on:click=\"handleShowModal('upload')\" v-if=\"user.role === 'admin'\" _v-6154f075=\"\"><span class=\"glyphicon glyphicon-plus\" _v-6154f075=\"\"></span><span _v-6154f075=\"\"> New</span></button></div></div><div class=col-xs-12 _v-6154f075=\"\"><pagination v-bind:sort-method.sync=sortMethod v-bind:sort-method-opts=sortMethodOpts v-bind:count-of-page.sync=countOfPage v-bind:curr-page.sync=currPage v-bind:count-of-pagination=countOfPagination v-bind:curr-pagination-sec.sync=currPaginationSec v-bind:target-ary.sync=customFilteredTotalLog _v-6154f075=\"\"></pagination><table class=\"table table-bordered table-hover log_table\" _v-6154f075=\"\"><tbody _v-6154f075=\"\"><tr v-for=\"($index, p) in customFilteredTotalLog | limitBy countOfPage pageStart\" _v-6154f075=\"\"><td _v-6154f075=\"\">{{$index + 1 + pageStart}}</td><td class=single_log _v-6154f075=\"\"><div class=media _v-6154f075=\"\"><div class=media-left _v-6154f075=\"\"><div class=\"media-object device_icon smart-controller\" v-bind:class=p.domain v-if=\"p.model !== 'all'\" _v-6154f075=\"\"><img v-bind:src=getIconSrc(p.category) _v-6154f075=\"\"></div><div class=\"media-object device_icon\" v-bind:class=p.domain v-else=v-else _v-6154f075=\"\"><img v-bind:src=getIconSrc(p.category) _v-6154f075=\"\"></div></div><div class=media-body _v-6154f075=\"\"><div class=media-top _v-6154f075=\"\"><span class=version _v-6154f075=\"\">{{p.version}}</span><span class=time _v-6154f075=\"\"><span class=\"glyphicon glyphicon-time\" _v-6154f075=\"\"></span><span _v-6154f075=\"\">Updated {{p.updatedAt | fromNow}}</span></span><span class=\"model type_tag base_black base_grey_bg\" _v-6154f075=\"\">{{getCustomForUI(p.custom)}}</span><span class=\"model type_tag base_grey_bg\" v-if=\"$route.name === 'smart-controller' &amp;&amp; p.domain != null\" v-bind:class=p.domain _v-6154f075=\"\">{{p.domain}}</span><div class=\"action_buttons pull-right\" _v-6154f075=\"\"><div class=btn-group _v-6154f075=\"\"><button class=\"btn btn-default\" @click=\"handleShowModal('update', p['.key'], $index)\" v-if=\"user.role === 'admin'\" _v-6154f075=\"\"><span class=\"glyphicon glyphicon-pencil\" _v-6154f075=\"\"></span></button><button class=\"btn btn-default\" @click=\"handleShowDeleteConfirm(p['.key'], p.category)\" v-if=\"user.role === 'admin'\" _v-6154f075=\"\"><span class=\"glyphicon glyphicon-trash\" _v-6154f075=\"\"></span></button><a class=\"btn btn-default\" v-if=\"p.category !== 'smart-controller' &amp;&amp; p.status === 'release' || user.role === 'admin'\" v-on:click=\"handleDownload(p.url, $event)\" _v-6154f075=\"\"><span class=\"glyphicon glyphicon-cloud-download\" _v-6154f075=\"\"></span><span v-if=\"$route.name === 'switch'\" _v-6154f075=\"\"> Firmware</span><span v-else=v-else _v-6154f075=\"\"> Download</span></a><a class=\"btn btn-default\" v-if=\"$route.name === 'switch' &amp;&amp; (p.category !== 'smart-controller' &amp;&amp; p.status === 'release' || user.role === 'admin')\" v-on:click=\"handleDownload(p.testReportUrl, $event)\" _v-6154f075=\"\"><span class=\"glyphicon glyphicon-list-alt\" _v-6154f075=\"\"></span><span _v-6154f075=\"\"> Test Report</span></a></div></div></div><div class=media-middle _v-6154f075=\"\"><line-table title=Features: v-bind:content=p.feature v-if=\"p.feature.length !== 0\" _v-6154f075=\"\"></line-table><line-table title=BugFixes: v-bind:content=p.bugFixed v-if=\"p.bugFixed.length !== 0\" _v-6154f075=\"\"></line-table></div></div><div class=\"media-right badge_group\" _v-6154f075=\"\"><div class=customized__badge v-bind:class=\"{'dev': p.status === 'dev', 'release': p.status === 'release', 'beta': p.status === 'beta', 'disabled': p.status === 'disabled'}\" _v-6154f075=\"\"><span _v-6154f075=\"\">{{p.status}}</span></div></div></div></td></tr></tbody></table></div></div><modal v-bind:title.sync=modalTitle v-bind:ok-text.sync=okText backdrop=false v-bind:callback=modalCb v-bind:show.sync=showModal _v-6154f075=\"\"><div class=\"modal-body upload_modal\" slot=modal-body _v-6154f075=\"\"><div class=\"col-xs-12 clearfix col-centered\" _v-6154f075=\"\"><div class=\"form-group col-xs-12 clearfix\" v-if=isUpdate _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Last update:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=isUpdatedAt readonly=readonly _v-6154f075=\"\"></div></div><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Category:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><v-select v-bind:options=category v-bind:value.sync=selectedCategory _v-6154f075=\"\"></v-select></div></div><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Custom:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><v-select v-bind:options=customOpts v-bind:value.sync=selectedCustom _v-6154f075=\"\"></v-select></div></div><div class=\"form-group col-xs-12 clearfix\" v-if=\"selectedCategory === 'smart-controller'\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Domain:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><v-select v-bind:options=domainOpts v-bind:value.sync=selectedDomain _v-6154f075=\"\"></v-select></div></div><div class=\"form-group col-xs-12 clearfix\" v-if=\"selectedCategory === 'smart-controller'\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Model:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><v-select v-bind:options=modelOpts v-bind:value.sync=selectedModel _v-6154f075=\"\"></v-select></div></div><div class=\"form-group col-xs-12 clearfix version\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Version:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=version v-bind:placeholder.sync=versionPlaceholder v-bind:class=\"{'error': showInvalidMsg}\" _v-6154f075=\"\"><span class=text-danger v-if=showInvalidMsg _v-6154f075=\"\">Please follow the format of placeholder</span></div></div><div v-if=\"$route.name === 'smart-controller'\" _v-6154f075=\"\"><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=\"control_label download\" _v-6154f075=\"\">Download Link:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=url placeholder=www.google.com _v-6154f075=\"\"></div></div></div><div v-else=v-else _v-6154f075=\"\"><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Firmware<span class=\"glyphicon glyphicon-cloud-download\" _v-6154f075=\"\"></span>:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=url placeholder=www.google.com _v-6154f075=\"\"></div></div><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Test Report:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=testReportUrl placeholder=www.google.com _v-6154f075=\"\"></div></div></div><div class=\"form-group col-xs-12 clearfix version\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">MD5:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><input class=\"form-control input-sm\" v-model=md5 _v-6154f075=\"\"></div></div><div class=\"form-group col-xs-12 clearfix\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Status:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><v-select v-bind:options=status v-bind:value.sync=selectedStatus _v-6154f075=\"\"></v-select></div></div><div class=\"form-group col-xs-12 clearfix larger_form_group\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Feature:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><textarea class=form-control v-model=feature placeholder=\"[TopologyView] support LLDP discover\n[EventLog] Cold Start Log.\" _v-6154f075=\"\"></textarea></div></div><div class=\"form-group col-xs-12 clearfix larger_form_group\" _v-6154f075=\"\"><div class=\"col-md-3 form_label clearfix\" _v-6154f075=\"\"><label class=control_label _v-6154f075=\"\">Bug Fixed:</label></div><div class=\"col-md-9 no_pad clearfix\" _v-6154f075=\"\"><textarea class=form-control v-model=bugFixed placeholder=\"[MSTP] If VLAN trunk is not the same to each other, the topology will loop.\" _v-6154f075=\"\"></textarea></div></div></div></div></modal><modal title=\"Confirm delete\" v-bind:show.sync=showDeleteConfirm _v-6154f075=\"\"><div class=modal-body slot=modal-body _v-6154f075=\"\"><h4 _v-6154f075=\"\">This operation is&nbsp;<span class=warning _v-6154f075=\"\">irreversible</span></h4><h4 _v-6154f075=\"\">Do you want to continue?</h4></div><div class=modal-footer slot=modal-footer _v-6154f075=\"\"><button class=\"btn btn-default\" @click=\"showDeleteConfirm = false\" _v-6154f075=\"\">Cancel</button><button class=\"btn btn-danger\" @click=applyDelete _v-6154f075=\"\">Yes, delete it</button></div></modal></div>";

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	module.exports = "<div class=container _v-622c38bb=\"\"><div class=row _v-622c38bb=\"\"><div class=\"login col-lg-5 col-md-6 col-sm-8 col-xs-10 col-centered clearfix\" _v-622c38bb=\"\"><div class=title _v-622c38bb=\"\"><span style=color:#ffcb2f _v-622c38bb=\"\">Controller</span><span _v-622c38bb=\"\">Hub</span></div><div class=content _v-622c38bb=\"\"><section class=input_group _v-622c38bb=\"\"><div class=\"input_single clearfix\" _v-622c38bb=\"\"><label _v-622c38bb=\"\">Account</label><input class=\"input form-control\" type=email name=acc placeholder=\"Enter your account\" v-model=account _v-622c38bb=\"\"></div><div class=\"input_single clearfix\" _v-622c38bb=\"\"><label _v-622c38bb=\"\">Password</label><input class=\"input form-control\" type=password name=pwd placeholder=\"Enter your password\" v-model=password v-on:keyup.enter=login _v-622c38bb=\"\"></div></section><section class=\"func_group clearfix row_space--xxs\" _v-622c38bb=\"\"><a class=\"btn login-btn btn-primary col-md-12 clearfix\" @click=login _v-622c38bb=\"\">Login</a></section><footer class=\"footer col-md-12\" _v-622c38bb=\"\"><a class=\"btn btn-no-bg col-md-12 col-sm-12 col-xs-12 clearfix\" @click=\"showForgetPw = true\" _v-622c38bb=\"\">Forgot password</a></footer></div></div><modal title=\"Please check your email box\" v-bind:show.sync=showMailHint effect=fade cancel-text=Cancel ok-text=\"I see\" _v-622c38bb=\"\"><div class=\"modal-body clearfix\" slot=modal-body _v-622c38bb=\"\"><div class=col-md-12 _v-622c38bb=\"\"><h2 _v-622c38bb=\"\">One more step to go....</h2><p _v-622c38bb=\"\">We will send a confirm email to your email box shortly, please check it to activate your account.</p></div></div><div class=\"modal-footer clearfix\" slot=modal-footer _v-622c38bb=\"\"><button class=\"btn btn-primary\" v-on:click=closeDialogs _v-622c38bb=\"\">I see</button></div></modal><modal title=\"Oops, seems like your Email has not been verified.\" v-bind:show.sync=showMailResend effect=fade cancel-text=Cancel ok-text=\"I see\" _v-622c38bb=\"\"><div class=\"modal-body clearfix\" slot=modal-body _v-622c38bb=\"\"><div class=col-md-12 _v-622c38bb=\"\"><h2 _v-622c38bb=\"\">Please check your email box .</h2><p _v-622c38bb=\"\">Or We can send the confirm email again.</p></div></div><div class=\"modal-footer clearfix\" slot=modal-footer _v-622c38bb=\"\"><button class=\"btn btn-primary\" v-on:click=resendMail _v-622c38bb=\"\">Send Again</button><button class=\"btn btn-primary\" v-on:click=closeDialogs _v-622c38bb=\"\">I see</button></div></modal><modal class=new_account_modal title=\"Creat new account\" v-bind:show.sync=showNewAccount effect=fade cancel-text=Cancel ok-text=Apply v-bind:callback=handleNewAccount _v-622c38bb=\"\"><div class=\"modal-body clearfix\" slot=modal-body _v-622c38bb=\"\"></div></modal><modal class=forget_pwd_modal title=\"Forgot your password\" v-bind:show.sync=showForgetPw effect=fade _v-622c38bb=\"\"><div class=\"modal-body clearfix\" slot=modal-body _v-622c38bb=\"\"><validator name=forgetPw _v-622c38bb=\"\"><div class=col-md-8 _v-622c38bb=\"\"><label _v-622c38bb=\"\">Enter your accout/email</label><input class=form-control type=email v-model=forgottenMail placeholder=\"please enter your account/email.\" v-validate:email=\"['email']\" _v-622c38bb=\"\"><span class=error v-show=\"$forgetPw.email.invalid &amp;&amp; $forgetPw.email.modified\" _v-622c38bb=\"\">Please enter a valid email address</span></div></validator></div><div class=\"modal-footer clearfix\" slot=modal-footer _v-622c38bb=\"\"><button class=\"btn btn-primary\" v-on:click=handleForget v-bind:disabled=$forgetPw.email.invalid _v-622c38bb=\"\">Send</button></div></modal></div></div>";

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	module.exports = "<div class=container _v-8687c052=\"\"><div class=row _v-8687c052=\"\"><h1 class=main_title _v-8687c052=\"\">{{$route.name}} Production Detail</h1><div class=col-md-6 _v-8687c052=\"\"><bs-input :value.sync=searchContent label=\"\" type=text _v-8687c052=\"\"><v-select slot=before v-bind:value.sync=searchBar.value v-bind:options=searchBar.opts _v-8687c052=\"\"></v-select><span class=input-group-addon slot=after _v-8687c052=\"\"><span class=\"glyphicon glyphicon-search\" _v-8687c052=\"\"></span></span></bs-input></div><div class=\"col-md-12 clearfix col-centered log_table\" _v-8687c052=\"\"><pagination v-bind:count-of-page.sync=countOfPage v-bind:curr-page.sync=currPage v-bind:count-of-pagination=countOfPagination v-bind:curr-pagination-sec.sync=currPaginationSec v-bind:target-ary.sync=outputData v-if=\"outputData.length > 10\" _v-8687c052=\"\"></pagination><table class=\"table table-hover table-bordered\" _v-8687c052=\"\"><tbody _v-8687c052=\"\"><tr _v-8687c052=\"\"><th _v-8687c052=\"\">Time</th><th _v-8687c052=\"\">Serial Number</th><th _v-8687c052=\"\">Mac address</th><th _v-8687c052=\"\">Domain</th><th _v-8687c052=\"\">Model</th><th _v-8687c052=\"\">Version</th><th _v-8687c052=\"\"></th></tr><tr v-for=\"l in outputData | orderBy 'startedAt' -1 | limitBy countOfPage pageStart\" _v-8687c052=\"\"><td _v-8687c052=\"\">{{l.startedAt | timeFormat}}</td><td _v-8687c052=\"\">{{l['.key']}}</td><td _v-8687c052=\"\">{{l.mac}}</td><td class=text-capitalize _v-8687c052=\"\">{{l.domain}}</td><td _v-8687c052=\"\">{{l.model}}</td><td _v-8687c052=\"\">{{l.fwVersion}}</td><td _v-8687c052=\"\"><div class=btn-group _v-8687c052=\"\"><button class=\"btn btn-default\" @click=showEditForm(l) _v-8687c052=\"\"><span class=\"glyphicon glyphicon-pencil\" _v-8687c052=\"\"></span></button><button class=\"btn btn-default\" @click=showDeleteConfirm(l) _v-8687c052=\"\"><span class=\"glyphicon glyphicon-trash\" _v-8687c052=\"\"></span></button></div></td></tr></tbody></table></div><div class=container _v-8687c052=\"\"><modal v-bind:show.sync=modalStatus v-bind:title=modalTitle v-bind:large=modalSize.large v-bind:small=modalSize.small _v-8687c052=\"\"><div class=modal-body slot=modal-body _v-8687c052=\"\"><div class=default_modal_content v-if=\"modalPurpose === null\" _v-8687c052=\"\">Hello world</div><div class=edit_modal_content v-if=\"modalPurpose === 'edit'\" _v-8687c052=\"\"><div class=form-horizontal _v-8687c052=\"\"><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputTime _v-8687c052=\"\">Time</label><div class=col-sm-9 _v-8687c052=\"\"><input class=form-control type=text id=inputTime v-model=modalData.startedAt disabled=disabled _v-8687c052=\"\"></div></div><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputSerialNumber _v-8687c052=\"\">Serial Number</label><div class=col-sm-9 _v-8687c052=\"\"><input class=form-control type=text id=inputSerialNumber v-model=\"modalData['.key']\" disabled=disabled _v-8687c052=\"\"></div></div><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputMac _v-8687c052=\"\">Mac address</label><div class=col-sm-9 _v-8687c052=\"\"><input class=form-control type=text id=inputMac v-model=modalData.mac disabled=disabled _v-8687c052=\"\"></div></div><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputModel _v-8687c052=\"\">Domain</label><div class=col-sm-9 _v-8687c052=\"\"><v-select class=\"btn-group btn-group-justified\" v-bind:options=\"[\n                      {label: 'Intri', value: 'intri'},\n                      {label: 'Eagleyes', value: 'eagleyes'},\n                      {label: 'EvoIP', value: 'evoip'},\n                      {label: 'AV Media', value: 'avmedia'}\n                    ]\" v-bind:value.sync=modalData.domain _v-8687c052=\"\"></v-select></div></div><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputModel _v-8687c052=\"\">Model</label><div class=col-sm-9 _v-8687c052=\"\"><v-select class=\"btn-group btn-group-justified\" v-bind:options=\"[\n                      {label: 'ASPEED', value: 'aspeed'},\n                      {label: 'ITE', value: 'ite'}\n                    ]\" v-bind:value.sync=modalData.model _v-8687c052=\"\"></v-select></div></div><div class=form-group _v-8687c052=\"\"><label class=\"col-sm-3 control-label\" for=inputVersion _v-8687c052=\"\">Version</label><div class=col-sm-9 _v-8687c052=\"\"><input class=form-control type=text id=inputVersion v-model=modalData.fwVersion _v-8687c052=\"\"></div></div></div></div><div class=delete_comfirm_content v-if=\"modalPurpose === 'deleteConfirm'\" _v-8687c052=\"\"><h4 _v-8687c052=\"\">This operation is<span class=warning _v-8687c052=\"\">irreversible!</span></h4><h4 _v-8687c052=\"\">Do you really want to continue?</h4></div></div><div class=modal-footer v-bind:class=\"{ 'hide': modalMethod === null }\" slot=modal-footer _v-8687c052=\"\"><div class=confirm v-if=\"modalMethod === 'confirm'\" _v-8687c052=\"\"><div class=pull-right _v-8687c052=\"\"><button class=\"btn btn-default\" @click=closeModal _v-8687c052=\"\">Cancel</button><button class=\"btn btn-danger\" @click=deleteData _v-8687c052=\"\">Confirm</button></div></div><div class=edit v-if=\"modalMethod === 'edit'\" _v-8687c052=\"\"><div class=pull-right _v-8687c052=\"\"><button class=\"btn btn-default\" @click=closeModal _v-8687c052=\"\">Cancel</button><button class=\"btn btn-primary\" @click=saveEdittedData _v-8687c052=\"\">Save</button></div></div></div></modal></div></div></div>";

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-cef6d4b8=\"\"><div class=col-md-12 _v-cef6d4b8=\"\"><h1 _v-cef6d4b8=\"\">{{msg}}</h1></div></div>";

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	module.exports = "<div class=container _v-e4dc8c34=\"\"><div class=row _v-e4dc8c34=\"\"><div class=col-xs-12 _v-e4dc8c34=\"\"><h1 class=main_title _v-e4dc8c34=\"\">{{$route.name}} Upgrade History</h1></div><div class=\"col-md-12 clearfix col-centered col-sm-12 col-xs-12\" _v-e4dc8c34=\"\"><div class=\"col-md-4 filter clearfix\" _v-e4dc8c34=\"\"><form class=form-horizontal _v-e4dc8c34=\"\"><div class=form-group _v-e4dc8c34=\"\"><label class=\"control-label h4\" _v-e4dc8c34=\"\">Filter</label><input class=\"form-control input-sm\" v-model=snFilter placeholder=\"Serial Number\" _v-e4dc8c34=\"\"></div></form></div><pagination v-bind:count-of-page.sync=countOfPage v-bind:curr-page.sync=currPage v-bind:count-of-pagination=countOfPagination v-bind:curr-pagination-sec.sync=currPaginationSec v-bind:target-ary.sync=filteredLog v-if=\"filteredLog.length > 10\" _v-e4dc8c34=\"\"></pagination><table class=\"table table-hover table-bordered\" _v-e4dc8c34=\"\"><tbody _v-e4dc8c34=\"\"><tr _v-e4dc8c34=\"\"><th _v-e4dc8c34=\"\">Serial Number</th><th _v-e4dc8c34=\"\">Date</th><th _v-e4dc8c34=\"\">Version</th><th v-if=\"user.role === 'admin'\" _v-e4dc8c34=\"\">Action</th></tr><tr v-for=\"h in filteredLog | orderBy 'startedAt' -1 | limitBy countOfPage pageStart\" _v-e4dc8c34=\"\"><td _v-e4dc8c34=\"\">{{h.sn}}</td><td _v-e4dc8c34=\"\">{{h.startedAt | timeFormat}}</td><td _v-e4dc8c34=\"\">{{h.version}}</td><td v-if=\"user.role === 'admin'\" _v-e4dc8c34=\"\"><button class=\"btn btn-xs btn-danger\" @click=\"deleteUpgHis(h['.key'])\" _v-e4dc8c34=\"\">Delete</button></td></tr></tbody></table></div></div></div>";

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(274)
	__vue_script__ = __webpack_require__(208)
	__vue_template__ = __webpack_require__(295)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(276)
	__vue_script__ = __webpack_require__(209)
	__vue_template__ = __webpack_require__(297)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(275)
	__vue_script__ = __webpack_require__(211)
	__vue_template__ = __webpack_require__(296)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(278)
	__vue_script__ = __webpack_require__(212)
	__vue_template__ = __webpack_require__(299)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(282)
	__vue_script__ = __webpack_require__(213)
	__vue_template__ = __webpack_require__(303)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(281)
	__vue_script__ = __webpack_require__(214)
	__vue_template__ = __webpack_require__(302)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(279)
	__vue_script__ = __webpack_require__(215)
	__vue_template__ = __webpack_require__(300)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(280)
	__vue_script__ = __webpack_require__(216)
	__vue_template__ = __webpack_require__(301)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })

});


// WEBPACK FOOTER //
// static/js/app.98eccd0bd0b7f235b464.js